import { fork } from "redux-saga/effects";
import watchTrackingQC from "./qc/saga";

const watchTracking = [
  fork(watchTrackingQC),
];

export default watchTracking;
